import * as Icons from "lucide-react";
import { RevealTitle, FadeIn } from "./Reveal";

export const ServicesSection = ({ services, texts }) => (
  <section data-testid="services-section" className="relative z-10 py-24 md:py-40 px-6 md:px-12 lg:px-24 bg-[#0D0D0D]">
    <p className="text-[#525252] tracking-[0.5em] text-xs uppercase mb-3">— Hizmetler</p>
    <RevealTitle testId="services-title" className="font-blackletter text-4xl sm:text-5xl lg:text-6xl text-[#EDEDEA] mb-16">
      {texts.services_title || "İş Birliği Modelleri"}
    </RevealTitle>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
      {services.map((s, i) => {
        const Icon = Icons[s.icon] || Icons.Star;
        return (
          <FadeIn key={s.id || i} delay={i * 0.06}>
            <div data-testid={`service-card-${i}`} className="service-card border border-[#232323] bg-[#111111] p-7 h-full">
              <Icon className="w-7 h-7 text-[#8B0000]" strokeWidth={1.5} />
              <h3 className="mt-5 text-base md:text-lg font-semibold text-[#EDEDEA]">{s.title}</h3>
              <p className="mt-2 text-sm text-[#A3A3A3] leading-relaxed">{s.description}</p>
            </div>
          </FadeIn>
        );
      })}
    </div>
  </section>
);
